// extracted by mini-css-extract-plugin
export default {"root":"RoomModal_root__lzImm","before":"RoomModal_before__dmeWW","label":"RoomModal_label__3krFS"};